/* @flow */

import React from 'react';
import { noop } from 'lodash/fp';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import StatusIcon from 'app/components/challenge/StatusIcon';
import {
  OPEN,
  IN_PROGRESS,
  IN_REVIEW,
  COMPLETED,
} from 'app/constants/challengeStatusTypes';
import useSheet from '../../jss';

type Props = {
  classes: Object,
  onChange?: (number) => void,
  selectedStatuses: Array<number>,
};

const defaultProps = {
  onChange: noop,
};

function ChallengeStatusToggleBox({
  classes,
  onChange,
  selectedStatuses,
}: Props) {
  return (
    <div className={classes.statuses}>
      {[OPEN, IN_PROGRESS, IN_REVIEW, COMPLETED].map(statusId => (
        <Tappable
          key={statusId}
          component="div"
          className={classes.statusContainer}
          onTap={() => onChange(statusId)}
        >
          <div
            className={classNames(classes.statusIconContainer, {
              active: selectedStatuses.includes(statusId),
            })}
          >
            <StatusIcon statusId={statusId} />
          </div>
        </Tappable>
      ))}
    </div>
  );
}

ChallengeStatusToggleBox.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    icon: {
      marginTop: '4px',
    },
    statuses: {
      display: 'flex',
      paddingTop: 5,
    },
    statusContainer: {
      display: 'flex',
      paddingRight: theme.spacing.small / 2,
      paddingLeft: theme.spacing.small / 2,
      '&:first-of-type': {
        paddingLeft: 0,
      },
      '&:last-child': {
        paddingRight: 0,
      },
    },
    statusIconContainer: {
      alignItems: 'center',
      borderColor: theme.color.basis2,
      borderRadius: '50%',
      borderStyle: 'solid',
      borderWidth: 1,
      color: theme.color.basis2,
      display: 'flex',
      fontSize: '1rem',
      height: 30,
      justifyContent: 'center',
      width: 30,
      '&.active': {
        backgroundColor: theme.color.basis2,
        color: theme.color.white,
      },
    },
    [theme.mediaQuery.desktopAndUp]: {
      statusIconContainer: {
        fontSize: '0.8rem',
        height: 24,
        width: 24,
        '&:not(.active):hover': {
          borderColor: theme.color.white,
          color: theme.color.white,

        },
      },
    },
  };
}

export default useSheet(applyStyles)(ChallengeStatusToggleBox);
